import TimbradoSftpInfoStore from './TimbradoSftpInfoStore';
import TimbradoSftpListStore from './TimbradoSftpListStore';
import TimbradoSftpUpsertStore from './TimbradoSftpUpsertStore';

const TimbradoSftpStore = {
  info: TimbradoSftpInfoStore,
  list: TimbradoSftpListStore,
  upsert: TimbradoSftpUpsertStore,
};

export default TimbradoSftpStore;
